import { HorizontalContainer } from '@american-autonomy/ag-ui';

import useTranslation from './hooks/useTranslation';

import OrgFieldPickerColumn from './components/OrgFieldPickerColumn';
import { FIELD_ROW_TEST_ID, ORGANIZATION_ROW_TEST_ID, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OrgFieldPicker: FunctionComponent<Props> = ({
    fields,
    isFieldsLoading,
    isOrganizationsLoading,
    onFieldSelect,
    onOrganizationSelect,
    organizations,
    selectedFieldId,
    selectedOrganizationId,
    testId = TEST_ID
}) => {
    const {
        FIELDS_LABEL,
        NO_FIELDS,
        NO_ORGANIZATIONS,
        ORGANIZATIONS_LABEL,
        SELECT_ORGANIZATION_PROMPT
    } = useTranslation();

    const showFieldsPrompt = !selectedOrganizationId;

    return (
        <HorizontalContainer className={styles.orgFieldPicker} testId={testId}>
            <OrgFieldPickerColumn
                emptyMessage={NO_ORGANIZATIONS}
                headerText={ORGANIZATIONS_LABEL}
                isLoading={isOrganizationsLoading}
                items={organizations}
                onItemClick={onOrganizationSelect}
                rowTestId={ORGANIZATION_ROW_TEST_ID}
                selectedItemId={selectedOrganizationId}
            />

            <OrgFieldPickerColumn
                emptyMessage={NO_FIELDS}
                headerText={FIELDS_LABEL}
                isLoading={isFieldsLoading}
                items={fields}
                onItemClick={onFieldSelect}
                promptMessage={SELECT_ORGANIZATION_PROMPT}
                rowTestId={FIELD_ROW_TEST_ID}
                selectedItemId={selectedFieldId}
                showPrompt={showFieldsPrompt}
            />
        </HorizontalContainer>
    );
};

export default OrgFieldPicker;
